{{#each this}}
  <li class='card' data-id='{{id}}'>
    {{#if poster_path}}
      <img
        class='card__img'
        src='https://image.tmdb.org/t/p/w500{{poster_path}}'
        alt='{{title}}'
        data-id='{{id}}'
      />
    {{else}}
      <img
        class='card__img'
        src='https://media.istockphoto.com/id/911590226/uk/%D0%B2%D0%B5%D0%BA%D1%82%D0%BE%D1%80%D0%BD%D1%96-%D0%B7%D0%BE%D0%B1%D1%80%D0%B0%D0%B6%D0%B5%D0%BD%D0%BD%D1%8F/%D0%B2%D0%B5%D0%BA%D1%82%D0%BE%D1%80%D0%BD%D0%B0-%D1%96%D0%BB%D1%8E%D1%81%D1%82%D1%80%D0%B0%D1%86%D1%96%D1%8F-%D1%87%D0%B0%D1%81%D1%83-%D1%84%D1%96%D0%BB%D1%8C%D0%BC%D1%83-%D0%BA%D0%BE%D0%BD%D1%86%D0%B5%D0%BF%D1%86%D1%96%D1%8F-%D0%BA%D1%96%D0%BD%D0%BE%D0%BF%D0%BE%D1%81%D1%82%D0%B5%D1%80%D1%83-%D0%BD%D0%B0-%D1%87%D0%B5%D1%80%D0%B2%D0%BE%D0%BD%D0%BE%D0%BC%D1%83-%D0%BA%D1%80%D1%83%D0%B3%D0%BB%D0%BE%D0%BC%D1%83-%D1%82%D0%BB%D1%96.jpg?s=612x612&w=0&k=20&c=xj1wHSzUN8OEHhOo8Xa_Z7FlJLxFXPppehw0-6KnmRs='
        alt='{{title}}'
        data-id='{{id}}'
      />
    {{/if}}
    <div class='card__box-info'>
      <h2 class='card__title'>{{title}}</h2>
      <div class='card__data'>
        {{#if genre_ids}}<span
            class='card__genres'
          >{{genre_ids}}</span>{{else}}<p class='card__undefined'>N/A</p>{{/if}}

        {{#if release_date}}<span class='card__year'>
            |
            {{release_date}}</span>{{else}}<p class='card__undefined'>| N/A</p>{{/if}}
      </div></div>
  </li>
{{/each}}